import React, { useState } from 'react'
import './MainBody.scss'
import { ReactComponent as SaveIcon } from "../assets/svg/body/material-save.svg";
import { ReactComponent as RightwardIcon } from "../assets/svg/body/rightward.svg";

import ToolKit from './ToolKit.js'
import PopUp from './PopUp';

function MainBodyTemp(props) {
    const mainBodyData = props.mainBodyData;
    const [topTabId, setTopTabId] = useState(0);
    const [subTabId, setSubTabId] = useState(0);
    return (
        <div className='MainBody'>
            {
                true ? <ToolKit /> : <PopUp popupData = {mainBodyData[topTabId]?.subTab[subTabId]?.popupData}/>
            }
            <div className='top-tabs'>
                {
                    mainBodyData?.map((topTabItem, topTabIndex) => {
                        return (
                            <div className='tab big' onClick={() => { setTopTabId(topTabIndex); setSubTabId(0) }} key={"topTabItem" + topTabIndex}>
                                <p>{topTabItem?.topTab}</p>
                                <div className={topTabId === topTabIndex ? 'underline' : 'hidden'}></div>
                            </div>
                        )
                    })
                }
            </div>
            <div className='middle-line'></div>
            <div className='top-tabs'>
                {
                    mainBodyData[topTabId]?.subTab?.map((subTabItem, subTabIndex) => {
                        return (
                            <div className='tab' onClick={() => setSubTabId(subTabIndex)} key={"subTabItem" + subTabIndex}>
                                <p>{subTabItem?.title}</p>
                                <div className={subTabId === subTabIndex ? 'underline' : 'hidden'}></div>
                            </div>
                        )
                    })
                }
            </div>
            <div className='middle-line'></div>
            <div className='main-table'>
                <table style={{ width: '100%' }}>
                    <tbody>
                        <tr>
                            {
                                mainBodyData[topTabId]?.subTab[subTabId]?.table?.heading.map((item, index) => {
                                    return (
                                        <th key={"MainBodyTableHeading" + index}>
                                            {item}
                                        </th>
                                    )
                                })
                            }
                            <th> <SaveIcon /> </th>
                        </tr>
                        {
                            mainBodyData[topTabId]?.subTab[subTabId]?.table?.data?.map((line, lineIndex) => {
                                return (
                                    <tr key={"MainBodyTableLine" + lineIndex}>
                                        {
                                            line?.map((item, index) => {
                                                if(index === 1 || index === 2 || index === 6)
                                                    return <td key={"MainBodyTableItem" + lineIndex + "-" + index}
                                                    style={{cursor : "pointer"}}
                                                    ><u>{item}</u></td>
                                                return <td key={"MainBodyTableItem" + lineIndex + "-" + index}>{item}</td>
                                            })
                                        }
                                        <td> <RightwardIcon className='rotate-clockwise' style={{marginRight : "15px"}}/> </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        </div >
    )
}

export default MainBodyTemp